<template>
  <div class="quick-wrap" v-show="show" @touchmove.prevent>
    <div class="quick-order">
      <div class="icon-close" @click="close">
        <span class="iconfont icon1">&#xe614;</span>
        <span class="iconfont icon2">&#xe606;</span>
      </div>
      <div class="quick-title-wrapper">
        <div class="quick-title">{{L.basicInfo}}</div>
      </div>
      <div class="inp-wrapper">
        <div class="inp-wrap">
          <div class="title">{{L.companyName}}:<span class="asterisk">*</span></div>
          <el-input size="mini" class="inp" v-model="obj.dealerName"></el-input>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.companyID}}:<span class="asterisk">*</span></div>
          <el-input size="mini" class="inp" v-model="obj.taxNumber"></el-input>
        </div>
        <div class="inp-wrap">
        <div class="title">{{L.legalPersonName}}:<span class="asterisk">*</span></div>
          <el-input size="mini" class="inp" v-model="obj.legalName"></el-input>
        </div>
        <div class="inp-wrap">
          <div class="title">{{L.legalPersonID}}:</div>
          <el-input size="mini" class="inp" v-model="obj.legalIdcard"></el-input>
        </div>
      </div>
      <div class="btn-wrapper">
        <div class="btn-wrap" @click="handleConfirm" v-loading="loading">
          <span>{{L.confirm}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {api_auth_basic_info_confirm} from '@/api/api'
import {postAction} from '@/api/tool'

export default {
  name:'Basic',
  data() {
    return {
      loading:false,
      show:false,
      obj:{
        dealerName:'',
        taxNumber:'',
        legalName:'',
        legalIdcard:''
      }
    }
  },
  methods:{
    open(obj){
      this.obj={
        dealerName:obj.dealerName,
        taxNumber:obj.taxNumber,
        legalName:obj.legalName,
        legalIdcard:obj.legalIdcard
      }
      this.show=true
    },
    close(){
      this.show=false
    },
    handleConfirm(){
      if(!this.obj.dealerName){
        this.$message.warning('Please enter the company name')
        return
      }
      if(!this.obj.taxNumber){
        this.$message.warning('Please enter the company ID')
        return
      }
      if(!this.obj.legalName){
        this.$message.warning('Please enter the legal person name')
        return
      }
      // if(!this.obj.legalIdcard){
      //   this.$message.warning('Please enter the legal person ID card')
      //   return
      // }
      
      this.loading=true
      postAction(api_auth_basic_info_confirm,this.obj).then(()=>{
        this.loading=false
        this.$message.success('Saved successfully')
        this.close()
        this.$emit('getAuth')
      }).catch(()=>{
        this.loading=false
      })
      
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../../public/css/public.less');
/* 快速下单 */
.quick-wrap{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  overflow: hidden;
  .quick-order{
    padding:30px 0;
    border-radius: 2px;
    position: absolute;
    &:extend(.main-box-shadow);
    width:600px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    box-sizing: border-box;
    text-align: left;
    .icon-close{
      position: absolute;
      right:14px;
      top:14px;
      .icon1{
        font-size: 24px;
        display: block;
        color:#888;
      }
      .icon2{
        font-size: 24px;
        display: none;
        color:@mainColor;
      }
      &:hover{
        cursor: pointer;
        .icon1{
          display: none;
        }
        .icon2{
          display: block;
        }
      }
    }
    .quick-title-wrapper{
      padding:0 40px 20px 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 26px;
      color:@mainColor;
      border-bottom: 1px solid @inpBorderClolr;
      // padding-bottom: 20px;
      // padding-top: 10px;
      .quick-title{
        // background-color: red;
        text-align: center;
      }
    }
    
    .inp-wrapper{
      padding:0 40px;
      .inp-wrap{
        font-size: 12px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        .title{
          text-align: right;
          width:160px;
          margin-right: 20px;
          .asterisk{
            color:@dangerColor;
            font-size: 12px;
            margin-left: 6px;
          }
        }
        .inp{
          flex: 1;
          color:@inpNumColor;
        }
      }
    }
    
    .btn-wrapper{
      padding:0 40px;
      .btn-wrap{
        font-size: 12px;
        margin-top: 26px;
        text-align: center;
        width:100%;
        color:#fff;
        background-color: @mainColor;
        padding:8px 6px;
        box-sizing: border-box;
        border:1px solid @mainColor;
        border-radius: 2px;
        &:extend(.transtion-time);
        &:hover{
          cursor: pointer;
          color:@mainColor;
          background-color: #fff;
          &:extend(.transtion-time);
        }
      }
    }
    
  }
}

</style>